"use strict";

document.addEventListener('DOMContentLoaded', function () {});